
export class ProgramApplicationNav {
  public static item = {
    title: 'program.tab.application',
    url: 'application',
    icon: '<img src="./assets/icons/line-icons/nav/grey/application.svg" width="23px" height="23px">',
    testId: 'prog-nav-application'
  };
}
